import DOWNLOAD_PLM_COLOR    from './downloadPlmColor.graphql'
import PLM_COLORS    from './plmColors.graphql'

export {PLM_COLORS, DOWNLOAD_PLM_COLOR}



// WEBPACK FOOTER //
// ./src/modules/common/graphql/plmColor/index.ts